/*
 * Copyright 2018 The boardgame.io Authors.
 *
 * Use of this source code is governed by a MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 */

import Multiview from './multiview';

const routes = [
  {
    path: '/liars-dice',
    text: 'Examples',
    component: Multiview,
  },
];

export default { routes };
